import { render, staticRenderFns } from "./ProcessDocumentCardTabRow.vue?vue&type=template&id=ec353830"
import script from "./ProcessDocumentCardTabRow.vue?vue&type=script&lang=js"
export * from "./ProcessDocumentCardTabRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports